<template>
    <SearchResultsPanel
        :title="title"
        @viewAll="viewAll"
        :showViewAll="showViewAll"
        :showCount="showCount"
        :count="executives.meta.resultCount"
    >
        <ul>
            <li v-for="executive in displayExecutives" :key="executive.id" class="search-result">
                <router-link
                    :to="{ name: 'executive-page', params: { id: executive.id } }"
                    @click.native.capture="event => $emit('navigating', event, executive)"
                >
                    <ExecutiveBadge :executive="executive" show-position size="medium" hide-popover />
                </router-link>
                <div class="button-group">
                    <button
                        class="primary small custom-work-button"
                        @click.stop.prevent="showCustomWorkModal(executive)"
                    >
                        Order Custom Work
                    </button>
                    <WatchlistButton :entity-type="executive.type" :entity-id="executive.id" class="small" />
                </div>
            </li>
        </ul>
    </SearchResultsPanel>
</template>
<script setup>
import { computed, inject } from 'vue'
import ExecutiveBadge from '../executives/executive-badge.vue'
import SearchResultsPanel from './SearchResultsPanel.vue'
import WatchlistButton from '@/components/shared/watchlist-button.vue'
import actions from '@/store/actions.js'

const props = defineProps({
    executives: {
        type: Object,
        required: true,
    },
    maxItems: {
        type: Number,
        required: true,
    },
    showCount: {
        type: Boolean,
        default: true,
    },
    showViewAll: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        default: 'Executive Results',
    },
})

const emit = defineEmits(['viewAll'])

const displayExecutives = computed(() => props.executives.results.map(i => i.entity).slice(0, props.maxItems))
const store = inject('store')

function showCustomWorkModal(executive) {
    store.dispatch(actions.showCustomWorkModal, { executives: [executive] })
}

function viewAll() {
    emit('viewAll')
}
</script>
<style scoped>
ul {
    display: flex;
    flex-direction: column;
}

li {
    display: flex;
    flex-direction: row;
}

li > a {
    flex: 1 1 1px;
    overflow: hidden;
}

li > .button-group {
    flex-shrink: 0;
}
</style>
